<div #preview id="preview"></div>
<div class="loader" [ngClass]="{'active':loading}"></div>
